<template>
  <a-select
    allow-clear
    show-search
    :value="value"
    :multiple="multiple"
    :placeholder="placeholder"
    option-filter-prop="title"
    @change="onChange"
    @clear="onClear"
    :class="class"
  >
    <a-select-option
      v-for="item in data?.records"
      :key="item.tenantUserId"
      :value="item.tenantUserId"
      :title="item.tenantUserName"
    >
      {{ item.tenantUserName }}
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, watch } from "vue";
import { UserSimpleListReq } from "./work-plan-user.interface";
import { WorkPlanUserService } from "./work-plan-user.service";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";

/**
 * 施工立项-项目组成员
 *
 */
export default defineComponent({
  name: "WorkPlanUserSelect",
  isGlobal: true,
  props: {
    value: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    activatedStatus: {
      type: Number,
      default: undefined,
    },
    projectId: {
      type: String,
      default: "",
    },
    status: {
      type: Number,
      default: undefined,
    },
    onJob: {
      type: Boolean,
      default: undefined,
    },
    staffType: {
      type: String,
      default: "no_type",
    },
    class: {
      type: String,
      default: "append-to-body w100",
    },
  },
  emits: ["update:value"],
  setup(props, { attrs, slots, emit }) {
    const { data, run, loading } = WorkPlanUserService.useSimpleListApi();
    let params = reactive(new UserSimpleListReq());
    const onChange = (id) => {
      emit("update:value", id);
    };

    const onClear = () => {
      emit("update:value", undefined);
    };
    watch(
      () => props.projectId,
      async () => {
        if (props.projectId) {
          await run(props.projectId);
        }
      },
      {
        immediate: true,
      }
    );
    onMountedOrActivated(async () => {
      if (props.projectId) {
        await run(props.projectId);
      }
    });

    return {
      data,
      loading,
      onChange,
      onClear,
    };
  },
});
</script>
